<template>
  <div class="app-container-v2 no-bg data-center" style="min-width: 990px;">
    <div class="top-container flex vertical br6 bg-white">
      <div class="title-box flex jbetween br6" style="border: none;">
        <div class="title-left flex acenter">
          <img class="cofco-trust-logo" src="@/assets/img/dashboard/COFCO-TRUST-logo.png" alt="" />
          <span class="title-text ml24">薪酬数据驾驶舱</span>
        </div>
        <div class="title-right flex jend acenter"></div>
      </div>
    </div>

    <div class="content-container mt24">
      <!--总体预算-->
      <overall-budget class="mb24" ref="overallBudget"></overall-budget>
      <!--预算执行情况-->
      <budget-performance class="mb24" ref="budgetPerformance"></budget-performance>
      <!--各部门情况-->
      <department class="mb24" ref="department"></department>
      <!--员工薪酬水平-->
      <salary ref="salary"></salary>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OverallBudget from './components/Dashboard/OverallBudget'
import BudgetPerformance from './components/Dashboard/BudgetPerformance'
import Department from './components/Dashboard/Department'
import Salary from './components/Dashboard/Salary'
export default {
  name: 'DataCenterDashboard',
  components: {
    Salary,
    BudgetPerformance,
    OverallBudget,
    Department
  },
  watch: {
    isCollapse(val) {
      setTimeout(() => {
        this.$refs.budgetPerformance.typeChange()
        this.$refs.department.initChart()
        this.$refs.salary.initChart()
      }, 500)
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
  },
  computed: {
    ...mapGetters(['isCollapse'])
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";
.cofco-trust-logo {
  height: 32px;
}
.data-center {
  .top-container {
    background: #FFFFFF;
  }
  .content-container {
  }
}
</style>
